import { render, staticRenderFns } from "./AssumptionsImpactsCurrentGridCleanEnergyShare.vue?vue&type=template&id=2679fb37&"
import script from "./AssumptionsImpactsCurrentGridCleanEnergyShare.vue?vue&type=script&lang=js&"
export * from "./AssumptionsImpactsCurrentGridCleanEnergyShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports